import { Box, Text } from '@chakra-ui/react'
import React from 'react'

const Header = () => {
  return (
    <>
        <Box w='full' p='2rem' h={['50%','50vh']} bg='#F5F8FF' display='flex' flexDirection='column' justifyContent='center' alignItems='center'>
            <Text fontSize={['24px','3rem']} color='#246BFD' textAlign='center' fontWeight='500' fontFamily='Duplicate Sans' >
                Contact Us
            </Text>
            <Text mt='1rem' color='#1F1F29' textAlign='center' noOfLines={2} lineHeight={['32px','']} fontSize={['12.5px','1rem']}  >
            We are always ready to assist you. <br/>
We’d love to hear from you.
            </Text>
        </Box>
    </>
  )
}

export default Header